<span *ngIf="label" class="label">
  {{ label }}
  <span *ngIf="isRequired()" class="required-asterisk">*</span>
</span>

<ng-container *ngIf="control?.enabled">
  <quill-editor
    (onEditorCreated)="onEditorCreated()"
    (onEditorChanged)="detectChanges()"
    #editor
    [formControl]="control"
    [modules]="modules"
    [placeholder]="placeholder"
  >
  </quill-editor>
  <mat-error>
    <wai-form-error [formField]="control"></wai-form-error>
  </mat-error>
</ng-container>

<wai-html-content *ngIf="control?.disabled" [content]="control?.value"></wai-html-content>
